import React, {Suspense, useEffect} from "react";
import {useDispatch} from "../useDispatch";
import {closeModal, setBlur} from "../helpers/actions";
import {useTypedSelector} from "helpers/reducers";
import "assets/ExtraStyle.css";
import Popup from "pages/Front/components/Popup";
import clsx from "clsx";
import AdminNavBarTop from "../pages/Front/components/AdminNavBarTop";
import AdminNavBarLeft from "../pages/Front/components/AdminNavBarLeft";

const AdminLayout = props => {
    // const session = useTypedSelector(state => state.session);
    const blur = useTypedSelector(state => state.blur);
    const dispatch = useDispatch();
    // if (!session) {
    //     window.location.href = "/";
    //     return null;
    // }
    useEffect(() => {}, []);
    return (
        <Suspense fallback={<div>Loading...</div>}>
            <div className="AdminLoggedLayout relative bg-white">
                <div className="LoggedLayoutOuter ml-auto mr-auto overflow-hidden justify-center z-20 rounded-4xl">
                    <div
                        className={clsx("LoggedLayoutInner overflow-hidden relative min-h-fullvh flex justify-center items-stretch pt-0 pl-0 rounded-tl-4xl")}
                        role="document"
                        style={{filter: blur && "blur(2px)"}}
                        onClick={() => {
                            if (blur) {
                                dispatch(setBlur(false));
                                dispatch(closeModal());
                            }
                        }}
                    >
                        <AdminNavBarTop />
                        <AdminNavBarLeft />
                        <div className="LoggedLayoutInner__content relative z-20 w-full ml-16 p-0 mt-16 shadow-inset rounded-tl-4xl overflow-hidden">
                            {props.children}

                            <div className="LoggedLayoutInnerBackground pointer-events-none absolute inset-0 overflow-hidden block w-full rounded-tl-4xl">
                                <div className="LoggedLayoutInnerBackground__gradient absolute inset-0 z-20 opacity-30 softlight softlight-gradient"></div>
                                <div className="LoggedLayoutInnerBackground__shadow absolute inset-0 z-1 bg-whitesmoke opacity-90 shadow-dash "></div>
                            </div>
                        </div>
                    </div>
                </div>
                <Popup />
                <div className="ref"></div>
            </div>
        </Suspense>
    );
};
export default AdminLayout;
